import { ContactDetails as DefaultContactDetails } from "src/components/feature/Onboarding";

const ContactDetails = () => {
  return <DefaultContactDetails />;
};

export default ContactDetails;
